import { render, staticRenderFns } from "./ImprintLink.vue?vue&type=template&id=05577be6&scoped=true&"
import script from "./ImprintLink.vue?vue&type=script&lang=js&"
export * from "./ImprintLink.vue?vue&type=script&lang=js&"
import style0 from "./ImprintLink.vue?vue&type=style&index=0&id=05577be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05577be6",
  null
  
)

export default component.exports